<template>
  <div style="width: 100%" v-if="mastersData">
    <user-list
      :usersData="filteredItems"
      :active="isActive"
      :type="type"
      :userData="engineerData"
      :newUserData="newEngineerData"
      :services="services"
      :request="request"
      :newEmplooyeeTitle="newEngineerTitle"
      :addEmployeeTitle="addEmployeeTitle"
      :changeView="changeModalView"
      :createdId="createdId"
      @addEmployee="addEngineer"
      @editEmployee="editEngineer"
      @deleteEmployee="deleteEngineer"
      @getEmployee="getEngineer"
      @setAvatar="setAvatarEngineer"
      @updateAvatar="updateEngineerAvatar"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
    props: ['type', 'isActive'],
    name: 'specialist-list',
    data() {
        return {
            newEngineerTitle: this.$t('pages.newEngineerTitle'),
            addEmployeeTitle: this.$t('pages.addEngineerTitle'),
            request: '',
            changeModalView: false,
        }
    },
    methods: {
        ...mapMutations({
            setAvatarSpecialist: 'specialists/setAvatarSpecialist',
            toggleSpecialistModal: 'specialists/setSpecialistModal',
            setStateSpecialist: 'specialists/setState',
        }),
        ...mapActions({
            getSpecialist: 'specialists/getSpecialist',
            addSpecialist: 'specialists/addSpecialist',
            editSpecialist: 'specialists/editSpecialist',
            deleteSpecialist: 'specialists/deleteSpecialist',
            updateSpecialistAvatar: 'specialists/updateSpecialistAvatar',
            requestForDelete: 'deleteControl/requestForDelete',
        }),
        changeView(view) {
            this.isActive = view
        },
        async getEngineer(id) {
            this.$Progress.start()

            await this.getSpecialist({ type: this.type, id })
            // await this.getSpecialistRequests(id);

            this.toggleSpecialistModal()
            this.$Progress.finish()
        },

        async addEngineer(id) {
            this.$Progress.start()

            const response = await this.addSpecialist({ type: this.type, id })

            if (response.status === 201) {
                this.$notify({
                    title: this.$t('notifications.masterAdded'),
                    message: this.$t('notifications.masterAddedText'),
                    duration: 3000,
                })

                this.toggleSpecialistModal()

                setTimeout(() => {
                    this.setStateSpecialist({
                        type: 'scheduleMasterId',
                        data: response.data.id,
                    })

                    this.setStateSpecialist({
                        type: 'isActive',
                        data: 'schedule',
                    })
                }, 500)
            }
        },
        async editEngineer(id) {
            this.$Progress.start()
            const status = await this.editSpecialist({ type: this.type, id })

            if (status) {
                this.$notify({
                    title: this.$t('notifications.masterUpdated'),
                    message: this.$t('notifications.masterUpdatedText'),
                    duration: 3000,
                })

                this.$Progress.finish()
                this.request = 'success'

                setTimeout(() => {
                    this.request = ''
                }, 500)
            }
        },
        async deleteEngineer(id) {
            this.$Progress.start()
            const upperCaseType = this.type
                .split('')
                .map((e, index) => {
                    if (index === 0) {
                        return e.toUpperCase()
                    }
                    return e
                })
                .join('')

            if (!this.$guard('delete', upperCaseType)) {
                await this.requestForDelete({
                    id,
                    type: this.type,
                })
                await this.fetchMasters()
                return
            }

            const response = await this.deleteSpecialist({ type: this.type, id })
            if (response.status === 409) {
                this.$notify({
                    title: this.$t('notifications.deleteMaster'),
                    message: this.$t('notifications.deleteMasterText'),
                    duration: 5000,
                })
            }

            await this.fetchMasters()
            this.$Progress.finish()
        },
        setAvatarEngineer(data, type) {
            this.setAvatarSpecialist({
                data,
                type,
            })
        },
        updateEngineerAvatar(id, data) {
            this.updateSpecialistAvatar({
                type: this.type,
                id,
                data,
            })
        },
        async fetchMasters() {
            await this.$store.dispatch('specialists/getSpecialistsData', {
                type: this.type,
            })
        },
    },
    computed: {
        ...mapGetters({
            mastersData: 'specialists/getSpecialists',
            engineerData: 'specialists/getSpecialist',
            newEngineerData: 'specialists/getNewSpecialist',
            services: 'servicesGetters',
            search: 'specialists/searchGetters',
            selectData: 'specialists/selectDataGetters',
        }),
        filteredItems() {
            return this.$store.state.specialists.data.filter((item) => {
                const result = []
                if (
                    item.last_name.toLowerCase().indexOf(this.search.toLowerCase())
            > -1
          && this.search
          && this.selectData
          && item.service.id.indexOf(this.selectData) > -1
                ) {
                    result.push(item)
                } else if (
                    item.first_name.toLowerCase().indexOf(this.search.toLowerCase())
            > -1
          && this.search
          && this.selectData
          && item.service.id.indexOf(this.selectData) > -1
                ) {
                    result.push(item)
                } else if (
                    item.phone.toLowerCase().indexOf(this.search.toLowerCase()) > -1
          && this.search
          && this.selectData
          && item.service.id.indexOf(this.selectData) > -1
                ) {
                    result.push(item)
                } else if (
                    item.email.toLowerCase().indexOf(this.search.toLowerCase()) > -1
          && this.search
          && this.selectData
          && item.service.id.indexOf(this.selectData) > -1
                ) {
                    result.push(item)
                } else if (
                    item.first_name.toLowerCase().indexOf(this.search.toLowerCase())
            > -1
          && this.search
          && !this.selectData
                ) {
                    result.push(item)
                } else if (
                    item.last_name.toLowerCase().indexOf(this.search.toLowerCase())
            > -1
          && this.search
          && !this.selectData
                ) {
                    result.push(item)
                } else if (
                    item.phone.toLowerCase().indexOf(this.search.toLowerCase()) > -1
          && this.search
          && !this.selectData
                ) {
                    result.push(item)
                } else if (
                    item.email.toLowerCase().indexOf(this.search.toLowerCase()) > -1
          && this.search
          && !this.selectData
                ) {
                    result.push(item)
                } else if (
                    item.service.id.indexOf(this.selectData) > -1
          && !this.search
                ) {
                    result.push(item)
                } else if (!this.search && !this.selectData) {
                    result.push(item)
                } else {
                    return false
                }
                return result
            })
        },
    },
}
</script>
